// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"5cb0fd66","203":"60955cae","811":"60955cae"}[chunkId] + ".chunk.css";
};